"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRadio = exports.RadioContextProvider = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var RadioContext = /*#__PURE__*/(0, _react.createContext)();

var RadioContextProvider = function RadioContextProvider(_ref) {
  var children = _ref.children,
      extra = _ref.extra;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      radioChecked = _useState2[0],
      setRadioChecked = _useState2[1];

  var propsProvider = {
    radioChecked: radioChecked,
    setRadioChecked: setRadioChecked
  };
  var value = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, propsProvider), extra);
  return /*#__PURE__*/_react.default.createElement(RadioContext.Provider, {
    value: value
  }, children);
};

exports.RadioContextProvider = RadioContextProvider;

var useRadio = function useRadio() {
  var context = (0, _react.useContext)(RadioContext);

  if (context === undefined) {
    throw new Error('useRadio deve ser usado dentro de um RadioContextProvider');
  }

  return context;
};

exports.useRadio = useRadio;